<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';

  :root {
    --cm-scrollbar-track: #e8eee8;
    --cm-scrollbar-thumb: #668269;
    --cm-scrollbar-thumb-hover: #4f6b53;
  }

  html,
  body,
  .c-app,
  .c-wrapper,
  .c-body {
    scrollbar-width: thin;
    scrollbar-color: var(--cm-scrollbar-thumb) var(--cm-scrollbar-track);
  }

  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  ::-webkit-scrollbar-track {
    background: var(--cm-scrollbar-track);
  }

  ::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #789479 0%, var(--cm-scrollbar-thumb) 100%);
    border-radius: 8px;
    border: 2px solid var(--cm-scrollbar-track);
  }

  ::-webkit-scrollbar-thumb:hover {
    background: var(--cm-scrollbar-thumb-hover);
  }
</style>
 